import React from 'react';
import Link from 'next/link';

const ArticleDmca = () => (
  <div className="article text-center py-5">
    <p className="h1">
      <b>404</b>
    </p>
    <p className="h4 my-4">We are sorry, page not found.</p>
    <p className="h5 my-4">
      The page you are looking for might have been removed has its name changed or is temporarily
      unavailable.
    </p>
    <p className="h5 my-4">
      <Link href="/">
        <a>Back to Homepage</a>
      </Link>
    </p>
  </div>
);

export default ArticleDmca;
